import React from 'react';

import { classNames } from '@/helpers/classNames';

import styles from './Legend.module.scss';

type LegendProps = {
	className?: string;
};

export const Legend: React.FC<LegendProps> = ({ className, children }) => {
	const classes = classNames([styles['root'], className]);

	return <div className={classes}>{children}</div>;
};

export const LegendItem: React.FC<{
	label: string;
	className: string;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
	dimmed?: boolean;
	circleColor?: string;
}> = ({ label, className, onMouseEnter, onMouseLeave, dimmed, circleColor }) => {
	return (
		<div
			className={classNames([styles['item'], className])}
			style={{ opacity: dimmed ? 0.4 : 1, transition: 'opacity 150ms ease' }}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<div className={styles['circle']} style={circleColor ? { background: circleColor } : undefined} />
			<div className={styles['label']}>{label}</div>
		</div>
	);
};
